export const AgecheckController = () => {

  // if(window.location.href.indexOf("sezoens") > -1 || window.location.href.indexOf("martens.staging.radikal.io") > -1) {
  //   // Set Sezoens cookie
  //   isSetCookie('sezoens_agecheck');
  // } else if (window.location.href.indexOf("kristoffel") > -1) {
  //   // Set Kristoffel cookie
  //   isSetCookie('kristoffel_agecheck');
  // }

  if($('.agecheck').length > 0) {
    window.allowScroll = false;

    $('.js-agree').on('click', (e) => {
      let cookieName = $(e.currentTarget).attr('data-cookie-name');
      setCookie(cookieName, true, 30);
      $('.agecheck').addClass('hide');
      $('body').removeClass('show-agecheck');
      window.allowScroll = true;
    })
  }


}

let setCookie = (name,value,days) => {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}



// let isSetCookie = (name) => {
//   if(!getCookie(name)) {
//     $('.agecheck').removeClass('hide');
//     window.allowScroll = false;

//     $('.js-agree').on('click', (e) => {
//       setCookie(name, true, 30);
//       $('.agecheck').addClass('hide');
//       window.allowScroll = true;
//     })
//   }
// }


// let getCookie = (name) => {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(';');
//   for(var i=0;i < ca.length;i++) {
//       var c = ca[i];
//       while (c.charAt(0)==' ') c = c.substring(1,c.length);
//       if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
//   }
//   return null;
// }



// WEBPACK FOOTER //
// ./src/js/controllers/AgecheckController.js